import Breadcrumb, { IBreadcrumbItem } from "../breadcrumb/breadcrumb";

import { BsArrowLeft } from "react-icons/bs";

import "./page.scss";
import { useEffect, useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { useParams } from "react-router";

import TextInput from "../../../shared/components/text-input/text-input";
import Tooltip from "../../../shared/components/tooltip/tooltip";
import { useBack } from "../../../shared/utils/use-back";

interface IPageProps {
  breadCrumbItems?: IBreadcrumbItem[];
  title?: {
    text: string;
    tooltip?: string;
    placeholder?: string;
    onTitleEdited?: (title: string) => void;
  }
  hasBackButton?: boolean;
  children: React.ReactNode;

}

const Page = ({ breadCrumbItems, title, hasBackButton = true, children }: IPageProps) => {
  const { handleBack } = useBack();
  const params = useParams();
  const [isEditingTitle, setIsEditingTitle] = useState(title?.text === "");

  useEffect(() => {
    if (params.id) {
      setIsEditingTitle(false);
    }
  }, [params]);

  const handleTitleEdited = (newTitle: string) => {
    title?.onTitleEdited?.(newTitle);
  };

  return (
    <div className="page">
      {hasBackButton && <div onClick={() => handleBack()} className="page-navButton">
        <BsArrowLeft />
      </div>}
      {title && <div className="page-header">
        <h1>
          {title.text}
          {title.tooltip && <Tooltip content={title.tooltip} direction="top" delay={350} />}
        </h1>
        {title.onTitleEdited && <FaPencilAlt onClick={() => setIsEditingTitle((prev) => !prev)} className="page-edit" />}
      </div>}
      {isEditingTitle && title && <div className="page-titleInput">
        <TextInput
          type={"text"}
          id={"title"}
          required={true}
          inputKey={"title"}
          handleOnChange={handleTitleEdited}
          controlled={true}
          autofocus={true}
          placeholder={title.placeholder || ""}
          value={title.text}
          toggleWarning={false}
        />
      </div>}
      {breadCrumbItems && <Breadcrumb breadCrumbItems={breadCrumbItems} />}
      {children}
    </div>
  );
};

export default Page;
